<div class="modal-wrap">
  <h3>전체 푸시 전송</h3>

  <ul class="detail-view">
    <li>
      <p class="tit">제목</p>
      <div class="cont-wrap">
        <input type="text" inputmode="text" minlength="1" placeholder="제목을 입력해주세요." />
      </div>
    </li>
    <li>
      <p class="tit">내용</p>
      <div class="cont-wrap">
        <textarea name="content" inputmode="text" minlength="1" placeholder="내용을 입력해주세요."></textarea>
      </div>
    </li>
  </ul>

  <div class="btn-wrap">
    <button type="button" class="btn btn-primary" (click)="close()">닫기</button>
    <!-- [확인] 선택 시 전체푸시전송 -->
    <button type="button" class="btn btn-primary" (click)="send()">전송</button>
  </div>
</div>
